
  import { Component, Prop, Vue } from "vue-property-decorator";
  import { Conversation, Message } from "@/generated/graphql";
  import CircleWithInitials from "@/components/card/CircleWithInitialsInbox.vue";
  import GroupConversationParticipants from "@/components/inbox/GroupConversationParticipants.vue";
import TooltipVariants from '@/entities/TooltipVariants';
  import ConversationParticipants from "@/entities/ConversationParticipants";
  import getConversationParticipants from "@/helpers/inboxHelpers/getConversationParticipants";
  import ConversationUserData from "@/entities/ConversationUserData";
  import RouteNames from "@/entities/RouteNames";
  import RouteParams from "@/entities/RouteParams";
  import moment from "moment";

  interface LastMessageDate {
    date: string,
    time: string,
  }

  @Component({
    components: {
      CircleWithInitials,
      GroupConversationParticipants,
    }
  })
  export default class InboxConversationItem extends Vue {
    @Prop({ type: String, required: true }) readonly currentUserId!: string;
    @Prop({ type: Object, default: () => ({}) }) readonly conversation!: Conversation;
    @Prop({ type: Boolean, default: false }) readonly selected!: boolean;

    showParticipants: boolean = false;
       TooltipVariants = TooltipVariants;

    get lastMessage(): Message | undefined {
      return this.conversation.messages[0];
    }
    get isUnRead(){
      return this.conversation.unread_view.length ? 'unreadMessage' : 'message';
    }
    get lastMessageContent(): string {
      if (!this.lastMessage?.content) {
        return "";
      }

      return this.lastMessage.content.replace("<br />", " ");
    }

    handleConversationClick(): void {
      this.$emit('select', this.conversation.id);
    }

    get lastMessageTime(): string {
      const date = this.lastMessage?.created_at;
      const dateNow = moment().format('MMM DD, YYYY');
      const messageDate = moment(date).format('MMM DD, YYYY');
      const messageTime = moment(date).format('h:mm a');
      let result;

      if (!date) {
        return "";
      }
      if (dateNow !== messageDate) {
        result = messageDate;
      }
      else{
        result = messageTime;
      }
      return result;
    }

    get onlyParticipantClass() {
      return [
        this.onlyParticipantLeft ? 'opacity-50' : 'opacity-100',
        this.conversation.unread_view.length ? 'unReadPersonName' : 'personName'
      ]
    }

    get recipients(): ConversationParticipants | undefined {
      return getConversationParticipants(this.conversation.users, this.currentUserId);
    }

    get isGroupConversation(): boolean {
      if (!this.recipients?.active) {
        return false;
      }
      return this.recipients.active.length > 1;
    }

    get firstRecipient(): ConversationUserData | undefined {
      if (!this.recipients?.all.length) {
        return undefined;
      }
      return this.recipients.all[0];
    }

    get onlyParticipantLeft(): boolean {
      return Boolean(this.firstRecipient && this.firstRecipient.deleted);
    }

    get conversationName(): string | undefined {
      if (!this.recipients?.all) {
        return undefined;
      }

      if (this.recipients.all.length == 0) {
        return 'no participants';
      }

      if (this.conversation.name) {
        return this.conversation.name;
      }

      return this.isGroupConversation
        ? this.recipients.all
          .map((recipient: any) => recipient.initial)
          .join(', ')
        : this.firstRecipient!.initial;
    }

    get conversationAvatar(): string | undefined {
      if (this.isGroupConversation || !this.firstRecipient) {
        return undefined;
      }
      return this.firstRecipient.avatar ?? undefined;
    }

    get numberOfParticipants(): number | undefined {
      if (!this.recipients?.active.length) {
        return undefined;
      }
      return this.recipients.active.length;
    }

    get conversationLink(): RouteParams<{ conversationId: string }> {
      return {
        name: RouteNames.INBOX_CONVERSATION,
        params: { conversationId: this.conversation.id }
      };
    }

    get conversationItemStyle(): string {
      return this.selected
        ? "borderRadius"
        : "bg-white hover:bg-gray-50 focus:bg-gray-50 border-l-4 border-transparent";
    }
  }
